import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { SchemaLocalBusiness } from '@/components/feature/SchemaOrg';
import Hero from './sections/Hero';
import TrustBanner from './sections/TrustBanner';
import ServiciosUrgentes from './sections/ServiciosUrgentes';
import SobreNosotros from './sections/SobreNosotros';
import Ventajas from './sections/Ventajas';
import Testimonios from './sections/Testimonios';
import CTAFinal from './sections/CTAFinal';

export default function Home() {
  return (
    <>
      <SchemaLocalBusiness />
      <Navbar />
      <main>
        <Hero />
        <TrustBanner />
        <ServiciosUrgentes />
        <SobreNosotros />
        <Ventajas />
        <Testimonios />
        <CTAFinal />
      </main>
      <Footer />
    </>
  );
}